import $http from "../axios";

const state = {
  inventoriesRefills: []
};

const getters = {
  inventoriesRefills: state => {
    return state.inventoriesRefills;
  },
  // A API devolve na ordem de gravação, então a tela ordena da operação mais
  // recente para a mais antiga. A cópia evita inverter o próprio estado a cada
  // leitura do getter, o que deixava a ordem instável.
  inventoriesRefillsNewestFirst: state => {
    return [...state.inventoriesRefills].sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  }
};

const actions = {
  getInventoriesRefills({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `inventories-refills?storeId=${data.storeId}&beginDate=${
            data.dates[0]
          }&endDate=${data.dates[1]}`
        )
        .then(res => {
          if (res.data.result === "ok") {
            commit(
              "SET_INVENTORIES_REFILLS",
              res.data.payload.inventoriesRefills
            );
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_INVENTORIES_REFILLS(state, inventoriesRefills) {
    state.inventoriesRefills = inventoriesRefills;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
